import { httpRequest } from "../../../http";

export class CommandDeleteNetworkResource {
  async run(resource_id: number) {
    try {
      await httpRequest<any>(
        `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content_network/network_accounts/network_resources/${resource_id}/`,
        {
          method: "DELETE",
        },
      );
    } catch (error) {
      console.error("Error creating network account:", error);
      throw error;
    }
  }
}
